export var BrandedNotification;
(function (BrandedNotification) {
    BrandedNotification["BRANDED_NOTIFICATION"] = "BRANDED_NOTIFICATION";
    BrandedNotification["PRIMARY_HEADER_BACKGROUND"] = "Primary Header Background";
    BrandedNotification["HEADER_DIVIDER"] = "Header Divider";
    BrandedNotification["SECONDARY_HEADER_TEXT"] = "Secondary Header Text";
    BrandedNotification["SECONDARY_HEADER_BACKGROUND"] = "Secondary Header Background";
    BrandedNotification["BODY_CONTENT1_TEXT"] = "Body Content 1 Text";
    BrandedNotification["BODY_CONTENT2_TEXT"] = "Body Content 2 Text";
    BrandedNotification["FOOTER_TEXT"] = "Footer Text";
    BrandedNotification["EMAIL_BODY_BACKGROUND"] = "Email Body Background";
    BrandedNotification["GET_STARTED_BUTTON_TEXT"] = "Get Started / Take Photos Button Text";
    BrandedNotification["GET_STARTED_BUTTON"] = "Get Started / Take Photos Button";
    BrandedNotification["COLORS"] = "Colors";
    BrandedNotification["CANCEL"] = "Cancel";
    BrandedNotification["EDIT"] = "Edit";
    BrandedNotification["SAVE"] = "Save";
    BrandedNotification["CONFIRM"] = "Confirm";
    BrandedNotification["LANGUAGE"] = "Language";
    BrandedNotification["RECIPIENT"] = "Recipient";
    BrandedNotification["BASE_TEMPLATE_TEXT"] = "Use Base Template From";
    BrandedNotification["EMAILS"] = "Emails";
    BrandedNotification["TEXT_MESSAGES"] = "Text Messages";
    BrandedNotification["LAST_UPDATED_BY"] = "Last updated by";
    BrandedNotification["LAST_UPDATED"] = "Last updated";
    BrandedNotification["ADD_LANGUAGE_TEMPLATE"] = "Add Language Template";
    BrandedNotification["ADD_TEMPLATE"] = "Add Template";
    BrandedNotification["NO_TEMPLATES_CREATED"] = "No Templates Created";
    BrandedNotification["SINGLE_LANGUAGE"] = "Single Language";
    BrandedNotification["NEW_LANGUAGE_TEMPLATE"] = "New Language Template";
    BrandedNotification["CREATE"] = "Create";
    BrandedNotification["WARNING_MESSAGE"] = "A template has already been created for the selected language(s).";
    BrandedNotification["WARNING_MESSAGE_EXISTING_TEMPLATE"] = "A template has already been created for the selected language(s) and selected recipient.";
    BrandedNotification["TEMPLATE_TYPE"] = "Template Type";
    BrandedNotification["MAIN_CONTENT_TEXT"] = "Text 1";
    BrandedNotification["SECONDARY_CONTENT_TEXT"] = "Text 2";
    BrandedNotification["CHANGE_BTN_TEXT"] = "Change";
    BrandedNotification["REMOVE_BTN_TEXT"] = "Remove";
    BrandedNotification["DEFAULT_IMG_TEXT"] = "Use Mitchell Default";
    BrandedNotification["LOGO_UPLOAD_BUTTON_LABEL_TEXT"] = "Upload Logo";
    BrandedNotification["SECONDARY_IMG_UPLOAD_BUTTON_LABEL_TEXT"] = "Upload Image";
    BrandedNotification["SECONDARY_HEADER_GRAPHIC_COLOR"] = "Secondary Header Graphic Color";
    BrandedNotification["LEFT_ALIGNED"] = "Left-Aligned";
    BrandedNotification["CENTER_ALIGNED"] = "Center-Aligned";
    BrandedNotification["RIGHT_ALIGNED"] = "Right-Aligned";
    BrandedNotification["STAY_HERE"] = "Stay Here";
    BrandedNotification["DONT_SAVE"] = "Don't Save";
    BrandedNotification["UNSAVED_CHANGES"] = "Unsaved Changes";
    BrandedNotification["LEFT_ALIGNED_VALUE"] = "left";
    BrandedNotification["CENTER_ALIGNED_VALUE"] = "center";
    BrandedNotification["RIGHT_ALIGNED_VALUE"] = "right";
    BrandedNotification["START_ALIGNED"] = "flex-start";
    BrandedNotification["END_ALIGNED"] = "flex-end";
    BrandedNotification["SCHEDULE_BUTTON_TEXT"] = "Schedule Repair Button Text";
    BrandedNotification["SCHEDULE_BUTTON"] = "Schedule Repair Button";
    BrandedNotification["DECODE"] = "decode";
    BrandedNotification["ENCODE"] = "encode";
    BrandedNotification["VIN"] = "VIN";
    BrandedNotification["VIN_STICKER"] = "VIN_STICKER";
})(BrandedNotification || (BrandedNotification = {}));
//# sourceMappingURL=BrandedNotification.js.map